/**
 * Preview-host redirect: `preview.kueez.website` is not a Pool website.
 * Without `?kz_domain=`, config fetch would fail — send testers to a real
 * domain (+ private/draft mode) before init continues.
 */

import { QueryParam } from './queryParams';

/** Hostname of the experience preview shell (not a Pool website). */
export const PREVIEW_HOST = 'preview.kueez.website';

/** Default Pool domain when previewing without an explicit `kz_domain`. */
export const PREVIEW_DEFAULT_DOMAIN = 'kueez.com';

/**
 * When the page is on the preview host and `kz_domain` is missing, navigate
 * to the same URL with `kz_domain=kueez.com` and `kz_prv=1`.
 *
 * @returns `true` if a redirect was triggered (caller must abort init).
 */
export function maybeRedirectPreviewMissingDomain(
  locationLike: Pick<Location, 'hostname' | 'href'> | null | undefined = typeof window !== 'undefined'
    ? window.location
    : undefined,
  replace: (url: string) => void = (url) => {
    if (typeof window !== 'undefined') window.location.replace(url);
  },
): boolean {
  if (!locationLike) return false;
  if (locationLike.hostname !== PREVIEW_HOST) return false;

  let url: URL;
  try {
    url = new URL(locationLike.href);
  } catch {
    return false;
  }
  if ((url.searchParams.get(QueryParam.Domain) ?? '').trim()) return false;

  url.searchParams.set(QueryParam.Domain, PREVIEW_DEFAULT_DOMAIN);
  url.searchParams.set(QueryParam.IncludeDrafts, '1');
  replace(url.toString());
  return true;
}
